import { Title, Subtitle, Field, SubmitButton, Modal } from '~components'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import { object, string } from '~utils/validation'
import { useStore, usePathValidation, useNavigate, useTitle } from '~hooks'
import { Values, Button } from './interfaces'
import { FormEvent, useState, useEffect } from 'react'
import mobile from 'is-mobile'
import * as Styled from './styled'
import { useRequest } from 'ahooks'
import { Vehicle } from '~services'
import { track } from '@amplitude/analytics-browser'

function Cellphone() {
  const modalPrimaryButton: Button = {
    text: 'Sim',
    type: 'submit',
  }
  const modalSecondaryButton = {
    onClick: handleClickModalSecondaryButton,
    text: 'Não',
  }
  const store = useStore()
  const navigate = useNavigate()

  const [openModal, setOpenModal] = useState(false)
  const defaultValues = {
    cellphone: store.register?.cellphone || '',
  }
  const schema = object({
    cellphone: string().cellphone('Celular inválido.'),
  })
  const {
    register,
    handleSubmit,
    watch,
    formState: { isValid, errors },
  } = useForm({ defaultValues, resolver: yupResolver(schema), mode: 'onChange' })

  const cellphone = watch('cellphone')

  useEffect(() => {
    track('cadastro_telefone')
  }, [])

  useEffect(() => {
    if (errors.cellphone && cellphone.length === 15) {
      track('cadastro_login_cpf', { errormessage: 'tel_invalido' })
    }
  }, [errors, cellphone])

  usePathValidation(['cpf'])
  useTitle('Fretebras - Encontre fretes perto de você de graça')
  useRequest(Vehicle.listTypes, {
    onSuccess: (data) => store.update({ vehicle: { types: data } }),
  })

  useRequest(Vehicle.listBodies, {
    onSuccess: (data) => store.update({ vehicle: { bodies: data } }),
  })

  function handleClickSecondaryButton() {
    navigate('/entrar', { state: { previousPath: '/cadastrar' } })
  }
  function handleShowValidation(value: string) {
    return value.length === 15
  }
  function handleClickPrimaryButton(event: FormEvent<HTMLButtonElement>) {
    if (!mobile()) {
      event.preventDefault()
      setOpenModal(true)
    }
  }
  function handleClickModalSecondaryButton() {
    navigate('/cadastrar/cadastre-pelo-celular', {
      state: { previousPath: '/cadastrar' },
    })
  }
  function onSubmit(values: Values) {
    store.update({ register: values })
    navigate('/cadastrar/nome-completo', { state: { previousPath: '/cadastrar' } })
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)} aria-labelledby="form-cellphone-title">
      <Title id="form-cellphone-title">
        O CPF {store.cpf} ainda não existe na Fretebras. Vamos cadastrar?
      </Title>
      <Subtitle>Digite o número de celular que você mais usa.</Subtitle>
      <Field
        defaultValue={defaultValues.cellphone}
        mask="(99) 99999-9999"
        name="cellphone"
        label="Celular"
        message="Use um número com WhatsApp, se possível."
        register={register}
        error={errors.cellphone}
        isValid={isValid}
        whenShowValidation={handleShowValidation}
        showSuccess
        type="tel"
      />
      <SubmitButton width="100%" disabled={!isValid} onClick={handleClickPrimaryButton}>
        Continuar
      </SubmitButton>
      <Styled.SecondaryButton onClick={handleClickSecondaryButton}>
        Outro CPF? Clique aqui.
      </Styled.SecondaryButton>
      <Modal
        open={openModal}
        title="Seu computador tem câmera?"
        message="Durante o cadastro vamos precisar da sua foto. Você consegue tirá-la com seu computador?"
        buttons={{ primary: modalPrimaryButton, secondary: modalSecondaryButton }}
      />
    </form>
  )
}

export default Cellphone
